
import { useEffect } from "react";

export function useVersionChecker(intervalMs = 60000) { // default: 1 minute
    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch("/config.json", {
                    cache: "no-store",
                });
                //if (!res.ok) return;
                const data = await res.json();

                if (data.version) {
                    let appVersion = localStorage.getItem('appVersion');
                    if (appVersion && data.version != appVersion) {
                        localStorage.setItem('appVersion', data.version);
                        console.log("New version detected:", data.version);
                        
                        await hardReloadSite();
                    }
                    else if(!appVersion){
                        localStorage.setItem('appVersion', data.version);
                    }


                }
            } catch (err) {
                console.error("Version check failed:", err);
            }
        };
        const id = setInterval(checkVersion, intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    const hardReloadSite = async () => {
        // 1. Clear Cache API
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(name => caches.delete(name)));
            console.log('Cache API cleared');
        }

        // 2. Unregister all Service Workers
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map(reg => reg.unregister()));
            console.log('Service workers unregistered');
        }

        // 3. Clear localStorage and sessionStorage
        localStorage.clear();
        sessionStorage.clear();
        console.log('localStorage and sessionStorage cleared');

        // 4. Clear all IndexedDB databases
        if ('indexedDB' in window && 'databases' in indexedDB) {
            const dbs = await indexedDB.databases();
            await Promise.all(dbs.map(db => indexedDB.deleteDatabase(db.name!)));
            console.log('IndexedDB cleared');
        }

        // 5. Force a hard reload (cache-busting)
        const url = window.location.origin + window.location.pathname;
        const cacheBustedUrl = url + '?t=' + new Date().getTime();
        window.location.replace(cacheBustedUrl);
    }
}